import React from 'react';
import { FadeIn } from './FadeIn';
import { Trophy, CheckCircle2 } from 'lucide-react';
export function SolutionOverview() {
  const benefits = ['Ahorrás tiempo real (y energía mental)', 'Te sentís más seguro/a en cada decisión', 'Resolución rápida de patologías frecuentes', 'Seguimiento con criterio cuando no avanza', 'Comunicación lista para decir (sin improvisar)'];
  return <section className="pt-8 pb-6 px-4 max-w-4xl mx-auto" data-id="element-257">
      <FadeIn className="text-center mb-8" data-id="element-258">
        <div className="inline-flex items-center gap-3 px-8 py-4 rounded-full border-2 border-mint/40 bg-mint/10 mb-4 pl-[32px] pr-[32px]" data-id="element-259">
          <span className="text-3xl" data-id="element-260">🏆</span>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-mint" data-id="element-261">
            Sistema N°1 para nutricionistas
          </h2>
        </div>

        <div className="bg-surface p-8 rounded-2xl shadow-md border border-mint/10 mb-6" data-id="element-262">
          <h3 className="font-bold text-2xl text-mint mb-2 bg-[#1A1525]" data-id="element-263">
            MEGAPACK NUTRI PRO
          </h3>
          <p className="text-lg text-white/70 mb-4" data-id="element-264">6 TOMOS + 6 BONOS</p>
          <p className="font-medium text-mint bg-mint/10 inline-block px-4 py-2 rounded-lg" data-id="element-265">
            +600 páginas. · Checklists · Protocolos · Guiones · Plantillas.
            Funciona desde hoy.
          </p>
        </div>
      </FadeIn>
    </section>;
}